const TOKEN_KEY = "xiaoyunque_c_token";
const USER_KEY = "xiaoyunque_c_user";
const PENDING_AI_DRAFT_KEY = "xiaoyunque_pending_ai_draft";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
  if (!token) {
    removeToken();
    return;
  }

  localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getUserProfile() {
  const rawValue = localStorage.getItem(USER_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    localStorage.removeItem(USER_KEY);
    return null;
  }
}

export function setUserProfile(user) {
  if (!user) {
    clearUserProfile();
    return;
  }

  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearUserProfile() {
  localStorage.removeItem(USER_KEY);
}

export function clearAuthState() {
  removeToken();
  clearUserProfile();
}

export function setPendingAiDraft(payload) {
  if (!payload) {
    clearPendingAiDraft();
    return;
  }

  sessionStorage.setItem(PENDING_AI_DRAFT_KEY, JSON.stringify(payload));
}

export function getPendingAiDraft() {
  const rawValue = sessionStorage.getItem(PENDING_AI_DRAFT_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    clearPendingAiDraft();
    return null;
  }
}

export function clearPendingAiDraft() {
  sessionStorage.removeItem(PENDING_AI_DRAFT_KEY);
}
